/** @format */

/**
 * Shared types and helpers for the paper-level import selection (QB2-223, DR8).
 * Kept separate from `PaperLevelForm.tsx` so the component file only exports a
 * component (React Fast Refresh constraint).
 */

export interface PaperLevelValues {
	paperCode: string;
	subject: string;
	/**
	 * Core qualification `code` (e.g. `alevel`) chosen from the Core dropdown
	 * (QB2-223). A free string, not the old GCSE/AS/A-Level enum — the Core API
	 * owns the qualification set and is a hard dependency (DR11); there is no
	 * enum fallback.
	 */
	qualification: string;
	/** Core tier `code` chosen from the Core dropdown; empty string = no tier (DR11). */
	tier: string;
	/** Core series (season) `code` chosen from the Core dropdown (DR11). */
	season: string;
	year: string;
	date: string;
}

export const EMPTY_PAPER_LEVEL: PaperLevelValues = {
	paperCode: "",
	subject: "",
	qualification: "",
	tier: "",
	season: "",
	year: "",
	date: "",
};

/** The paper-level selection is complete enough to build a Paper. */
export const isPaperLevelComplete = (values: PaperLevelValues): boolean =>
	Boolean(
		values.paperCode.trim() &&
		values.subject.trim() &&
		values.qualification &&
		values.season &&
		values.year.trim() &&
		values.date.trim(),
	);
